<template>
    <div class="search-list-headline" v-if="!getShowSubjectAreaBanner($totemLang)">
        <h1 class="search-list-headline__title" v-html="headline.title"></h1>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'SearchListHeadline',
        props: {
            headline: {
                type: Object
            }
        },
        computed: {
            ...mapGetters({
                mainPackage: 'Search/selectedMainPackage',
                getShowSubjectAreaBanner: 'Search/getShowSubjectAreaBanner'
            })
        }
    }
</script>

<style lang="scss" scoped>
    .search-list-headline {
        background: $white;
        position: relative;
        z-index: 1;
        margin-top: -30px;

        [class*="desktop"] & {
            padding: 40px 0 0 0;
        }

        &__title {
            color: $lavender;
            margin: 0 0 20px;
            word-break: break-all;

            [class*="mobile"] & {
                margin: 30px 0 0 0;
                word-break: break-word;
            }
        }
    }
</style>
